import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import {TranslateService} from "@ngx-translate/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { LyDialog } from '@alyle/ui/dialog';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import * as $ from 'jquery';

import { ModalImgComponent } from "app/main/pagina/productos/certificar/tipo_2/editor-encuesta/modal-img/modal-img.component";
import { EditorBrokerService } from "./editor-broker.service";
import { CloudService } from 'app/main/pagina/tools/cloud/cloud.service';
import { lang_editorBroker } from 'app/idiomas/i18n/editor-broker/editor-broker.lang';
import paginas from "./catalogo-elementos";
import * as catalogos from "./editor-broker.catalogos";
import { DATOS_API } from 'app/auth/auth.datos';
import { ModalImportarComponent } from "./modal-importar/modal-importar.component";
import { ModalEditorComponent } from "app/main/pagina/productos/certificar/tipo_2/editor-encuesta/modal-editor/modal-editor.component";

@Component({
  selector: 'app-editor-broker',
  templateUrl: './editor-broker.component.html',
  styleUrls: ['./editor-broker.component.scss'],
  animations   : fuseAnimations
})
export class EditorBrokerComponent implements OnInit {

  institutos:any;
  idiomas = [
    {id   : 'en'},
    {id   : 'es'},
    {id   : 'tr'},
    {id   : 'zh1'},
    {id   : 'zh2'},
    {id   : 'pt'},
    {id   : 'de'},
    {id   : 'nl'},
    {id   : 'ru'},
  ];
  paginas: any;
  cargando: boolean;
  brokerElegido: any;
  jsonsConfiguracion: any = {};
  datasets: FormGroup[] = [];
  idEmpresa = "0";
  direccionRaiz = "./4fa42aa0ba652605cada43bca0fc6389/";
  guardandoTemplate = false;
  jsonsEncontrados = false;
  carpetasBrokers: any;
  imgGuardadasTmp: number;
  datosFlagBroker: any;
  catalogosListas = catalogos;
  templatesCorreos: any = {};
  guardandoArchivo = false;
  progresoCarga: number = 0;

  constructor(
    private ebs: EditorBrokerService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private _dialog: LyDialog,
    private _cd: ChangeDetectorRef,
    private cloudService: CloudService,
    private dialog: MatDialog,
  ) {
    lang_editorBroker.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.paginas = paginas;
    this.getInstitutos();
  }

  getInstitutos(){
    this.ebs.getInstitutos().subscribe((respuesta:any) => {
      console.log("getInstitutos:",respuesta);
      this.institutos = respuesta.Institutos;
      this.getRaiz();
    });
  }

  eligeBroker(broker:any){
    console.log("broker:",broker);
    this.jsonsConfiguracion = {};
    this.cargando = true;
    this.ebs.getJsons(broker).subscribe((respuesta:any) => {
      console.log("getJsons:",respuesta);
      if(respuesta.jsonCGO.length > 0){
        this.jsonsEncontrados = true;
        respuesta.jsonCGO.forEach(json => {
          if(!this.jsonsConfiguracion[json.lang]){
            this.jsonsConfiguracion[json.lang] = json;
          }
        });
        console.log("jsonsConfig:",this.jsonsConfiguracion);
        this.creaFormGroups();
        this.getFlagBroker(broker);
        this.getCorreosBroker(broker);
      } else{
        this.jsonsEncontrados = false;
      }
      this.cargando = false;
    });
  }

  getCorreosBroker(broker:number){
    this.ebs.getCorreos(broker).subscribe((respuesta:any) => {
      console.log("getCorreos:",respuesta);
      this.templatesCorreos = {};
      respuesta.correos_CGO.forEach(correo => {
        if(!this.templatesCorreos[correo.lang]){
          this.templatesCorreos[correo.lang] = { [correo.tipo]: correo };
        } else{
          if(!this.templatesCorreos[correo.lang][correo.tipo]){
            this.templatesCorreos[correo.lang][correo.tipo] = correo;
          }
        }
      });
      console.log("objCorreos:",this.templatesCorreos);
      let referenciaDataSet = this.datasets;
      console.log("controlesCorreos:",referenciaDataSet[2].controls);
      for(let idiomaCorreos in this.templatesCorreos){
        let refIdioma = this.templatesCorreos[idiomaCorreos];
        for(let tipoCorreo in refIdioma){
          let refCorreo = refIdioma[tipoCorreo];
          let claveAsunto = `${refCorreo.lang}_templates_${refCorreo.tipo}_asunto`;
          console.log("controlesCorreos:",claveAsunto);
          let claveMensaje = `${refCorreo.lang}_templates_${refCorreo.tipo}_mensaje`;
          let claveHabilitado = `${refCorreo.lang}_templates_${refCorreo.tipo}_habilitado`;
          let claveIdTemplate = `${refCorreo.lang}_templates_${refCorreo.tipo}_idTemplate`;
          referenciaDataSet[2].controls[claveAsunto] !=undefined? referenciaDataSet[2].controls[claveAsunto].setValue(refCorreo.asunto) :false;
          referenciaDataSet[2].controls[claveMensaje] !=undefined? referenciaDataSet[2].controls[claveMensaje].setValue(refCorreo.html) :false;
          referenciaDataSet[2].controls[claveHabilitado] !=undefined? referenciaDataSet[2].controls[claveHabilitado].setValue(true) :false;
          referenciaDataSet[2].controls[claveIdTemplate] !=undefined? referenciaDataSet[2].controls[claveIdTemplate].setValue(refCorreo._id) :false;
        }
      }
      console.log(`formgroupsActualizado:`,referenciaDataSet);
    });
  }

  getFlagBroker(broker:number){
    this.ebs.getFlag(broker).subscribe((respuesta:any) => {
      console.log("getFlag:",respuesta);
      if(respuesta.success){
        this.datosFlagBroker = respuesta.flagStatus;
      }
    });
  }

  cambiaFlagBroker(){
    // console.log("datosflag:",this.datosFlagBroker);
    let tituloModal: string;
    let rspSi = this.translateSrv.instant('MODALES.ACCIONES.aceptar');
    let rspNo = this.translateSrv.instant('MODALES.ACCIONES.cancelar');
    if(this.datosFlagBroker.flag == true){  //si se activa la bandera
      tituloModal = this.translateSrv.instant('EDITOR.ADVERTENCIAS.CONFIGURACION.ACTIVAR');
    } else{ //si se desactiva la bandera
      tituloModal = this.translateSrv.instant('EDITOR.ADVERTENCIAS.CONFIGURACION.DESACTIVAR');
    }
    Swal.fire({
      title: tituloModal,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        this.guardandoTemplate = true;
        this.ebs.updateFlag(this.datosFlagBroker._id, { flag:this.datosFlagBroker.flag }).subscribe((respuesta:any) => {
          console.log("updateFlag:",respuesta);
          if(respuesta.success){
            this.guardandoTemplate = false;
          }
        });
      } else{
        this.datosFlagBroker.flag = !this.datosFlagBroker.flag;
      }
    });
  }

  configDominio(){
    const dialogRef = this.dialog.open(ModalImportarComponent, {
      width: '50%',
      disableClose: true,
      data: {
        tipo: 'dominio',
        domain: this.datosFlagBroker.domain,
        dominios: this.catalogosListas.dominios
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("result:",result);
      if(result != undefined){
        this.datosFlagBroker.domain = result;
        this.guardandoTemplate = true;
        this.ebs.updateFlag(this.datosFlagBroker._id, { flag:this.datosFlagBroker.flag, domain:this.datosFlagBroker.domain }).subscribe((respuesta:any) => {
          console.log("updateFlag:",respuesta);
          if(respuesta.success){
            this.guardandoTemplate = false;
          }
        });
      }

    });
  }

  creaFormGroups(){
    this.datasets = [];
    let referenciaDataSet = this.datasets;
    let dataSetActual = 0;
    let group = {};
    this.paginas.forEach(pagina => {
      if(dataSetActual != pagina.pagina){
        if(dataSetActual > 0){
          referenciaDataSet.push(new FormGroup(group) );
        }
        dataSetActual = pagina.pagina;
        group = {};
      }

      pagina.pasos.forEach(paso => {
        if(paso.tipo == 'fijo'){
          paso.elementos.forEach(elemento => {
            this.idiomas.forEach(idioma => {
              group[`${idioma.id}_${pagina.id}_${paso.id}_${elemento.id}`] = new FormControl('', Validators.required);
            });
          });
        }
      });
    });

    //inserta el ultimo formgroup
    referenciaDataSet.push(new FormGroup(group) );
    // console.log("formgroups:",referenciaDataSet);
    this.colocaValores();

    // this.datasets.forEach((dataset,i) => {
    //   dataset.valueChanges.subscribe( (res) => {
    //     if(dataset.status == 'VALID'){
    //       this.formValido = this.formValido && true;
    //     }
    //     else{
    //       this.formValido = this.formValido && false;
    //     }
    //   });
    // });
  }

  colocaValores(){
    let referenciaDataSet = this.datasets;
    let referenciaJsons = this.jsonsConfiguracion;
    referenciaDataSet.forEach((dataset,idxPag) => {
      for(let control in dataset.controls){
        let camino = control.split("_");
        this.navegaJsonRecursivo(idxPag,control,referenciaJsons,camino,0,null,true);
      }
    });
    console.log(`formgroups:`,referenciaDataSet);

    // this.faseCarga++;
    // if(this.faseCarga == 2){
    //   this.buscaModificacionesPasos(this.idiomaNative);
    //   this.cargando = false;
    // }
  }

  abreModalEditor(idxPag:number, pagina:string, paso:string, elemento:string, idioma:string, tituloModal:string){
    let texto = this.datasets[idxPag].controls[`${idioma}_${pagina}_${paso}_${elemento}`].value;
    let indiceBroker = this.institutos.findIndex(item => item.numInstituto == this.brokerElegido);
    let carpetaBroker = this.carpetasBrokers[this.institutos[indiceBroker].indiceCarpeta];
    const dialogRef = this.dialog.open(ModalEditorComponent, {
      width: '70%',
      disableClose: true,
      data: {
        opcion: 'editar',
        texto,
        tituloModal,
        carpetaBroker
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.via == 1){
        if(result.texto != texto){
          console.log("son diferentes");
          this.datasets[idxPag].controls[`${idioma}_${pagina}_${paso}_${elemento}`].setValue(result.texto);
          this.modificaTemplateCorreo(idxPag, pagina, paso, elemento, idioma);
        } else{
          console.log("son iguales");
        }
      }
    });
  }

  importarImagen(indicePagina:number, idioma:string, pagina:string, paso:string, elemento:string, backgrounds?:boolean){
    const dialogRef = this.dialog.open(ModalImportarComponent, {
      width: '50%',
      disableClose: true,
      data: {
        idiomas: this.idiomas,
        idiomaActual: idioma
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("result:",result);
      if(result != undefined){
        let indiceBroker = this.institutos.findIndex(item => item.numInstituto == this.brokerElegido);
        let carpetaBroker = this.carpetasBrokers[this.institutos[indiceBroker].indiceCarpeta];
        let claveOrigen = `${result}_${pagina}_${paso}_${elemento}`;
        let claveDestino = `${idioma}_${pagina}_${paso}_${elemento}`;
        if(backgrounds == undefined){
          let referenciaDataSet = this.datasets;
          let rutaImgOrigen = referenciaDataSet[indicePagina].controls[claveOrigen].value;
          let refImgDestino = referenciaDataSet[indicePagina].controls[claveDestino].value;
          if(rutaImgOrigen != ""){  // si hay una imagen en el idioma origen
            this.cloudService.getCarpeta(carpetaBroker._id).subscribe((respuesta:any) => {
              if(respuesta.success){
                rutaImgOrigen = rutaImgOrigen.split("/");
                let nombreImgOrigen = rutaImgOrigen[rutaImgOrigen.length - 1];
                let indiceArchivo = respuesta.archivos.findIndex(item => item.nombre == nombreImgOrigen);
                let nombreImgDestino = `${idioma}_${pagina}_${paso}_${elemento}_${Date.now()}`;
                // console.log("datosImagen:",respuesta.archivos[indiceArchivo]);
                // console.log("datosCarpeta:",carpetaBroker);
                // console.log("nombreImagen:",nombreImgDestino);
                let datosCopia = {
                  idArchivo: respuesta.archivos[indiceArchivo]._id,
                  carpetaId: carpetaBroker._id,
                  newNameFile: nombreImgDestino
                };
                if(refImgDestino == ""){  //si no hay una imagen en el idioma destino
                  this.copiarImagen({datosCopia, rutaImgOrigen, claveDestino, indicePagina, idioma, pagina, paso, elemento});
                } else{
                  this.borrarImagen(idioma, pagina, null, null, {datosCopia, rutaImgOrigen, claveDestino, indicePagina, idioma, pagina, paso, elemento});
                }
              }
            });
          }
        } else{
          let arregloImagenes = this.jsonsConfiguracion[result][pagina].backgrounds;
          if(arregloImagenes.length > 0){
            this.cloudService.getCarpeta(carpetaBroker._id).subscribe((respuesta:any) => {
              if(respuesta.success){
                this.imgGuardadasTmp = 0;
                arregloImagenes.forEach(imagen => {
                  let rutaImgOrigen = imagen.image.split("/");
                  let nombreImgOrigen = rutaImgOrigen[rutaImgOrigen.length - 1];
                  let indiceArchivo = respuesta.archivos.findIndex(item => item.nombre == nombreImgOrigen);
                  let nombreImgDestino = `${idioma}_${pagina}_${paso}_${Date.now()}`;
                  // console.log("datosImagen:",respuesta.archivos[indiceArchivo]);
                  // console.log("datosCarpeta:",carpetaBroker);
                  // console.log("nombreImagen:",nombreImgDestino);
                  if(indiceArchivo != -1){
                    let datosCopia = {
                      idArchivo: respuesta.archivos[indiceArchivo]._id,
                      carpetaId: carpetaBroker._id,
                      newNameFile: nombreImgDestino
                    };
                    this.copiarImagen({datosCopia, rutaImgOrigen, claveDestino, indicePagina, idioma, pagina, paso, elemento},arregloImagenes.length);
                  }
                });
              }
            });
          }
        }
      }

    });
  }

  copiarImagen(datosBypass: any, tamanioArreglo?:number){
    let referenciaDataSet = this.datasets;
    this.cloudService.copiaArchivo(datosBypass.datosCopia).subscribe((respCopia:any) => {
      console.log("copiaArchivo:", respCopia);
      let rutaImgDestino: string = '';
      datosBypass.rutaImgOrigen.forEach((frag, i) => {
        if(i < (datosBypass.rutaImgOrigen.length - 1)){
          rutaImgDestino = rutaImgDestino + frag + "/";
        } else{
          rutaImgDestino = rutaImgDestino + respCopia.archivo.nombre;
        }
      });
      if(tamanioArreglo == undefined){
        referenciaDataSet[datosBypass.indicePagina].controls[datosBypass.claveDestino].setValue(rutaImgDestino);
        this.modificarDatoJson(datosBypass.indicePagina, datosBypass.pagina, datosBypass.paso, datosBypass.elemento, datosBypass.idioma);
      } else{
        this.imgGuardadasTmp++;
        console.log(`imagenes copiadas: ${this.imgGuardadasTmp}/${tamanioArreglo}`);
        this.jsonsConfiguracion[datosBypass.idioma][datosBypass.pagina].backgrounds.push({
          image: rutaImgDestino
        });
        if(this.imgGuardadasTmp == tamanioArreglo){
          this.actualizaJson(datosBypass.idioma);
        }
      }
    });
  }

  zoomImagen(url:string, opcion:number){
    let tagImagen:string;
    switch (opcion) {
      case 1: //imagen
        tagImagen = `<img src="${url}" alt="" width="100%">`;
      break;
      case 2: //video
        tagImagen = `<video src="${url}" alt="" width="100%" autoplay controls>`;
      break;
    }
    Swal.fire({
      // title: this.translateSrv.instant('EDITOR.ELEMENTOS.GUIA'),
      // html: '<img src="https://www.harley-davidson.com/content/dam/h-d/images/product-images/bikes/motorcycle/2021/2021-sport-glide/2021-sport-glide-f16/2021-sport-glide-f16-motorcycle.jpg" alt="" width="100%">',
      html: tagImagen,

      confirmButtonText: 'OK',
      width: '80%'
    });
  }

  borrarImagen(idioma:string, pagina:string, idxBg?:number, datosBypass?:any, datosBypCopia?:any){
    let indiceBroker = this.institutos.findIndex(item => item.numInstituto == this.brokerElegido);
    let carpetaBroker = this.carpetasBrokers[this.institutos[indiceBroker].indiceCarpeta];
    let nombreImagen: string = '';
    if(idxBg != null){
      let rutaImagen = this.jsonsConfiguracion[idioma][pagina].backgrounds[idxBg].image.split('/');
      nombreImagen = rutaImagen[rutaImagen.length-1];
    } else{
      if(datosBypass != null){
        let claveImagen: string[];
        if(datosBypass.formData != undefined){
          claveImagen = datosBypass.formData.get('file').name.split('_');
        } else{
          claveImagen = datosBypass.file.name.split('_');
        }
        console.log("claveImg:",claveImagen);
        claveImagen.forEach((clave,i) => {
          if(i < (claveImagen.length - 1)){
            nombreImagen = nombreImagen + clave;
            if(i < (claveImagen.length - 2)){ nombreImagen = nombreImagen + "_"; }
          }
        });
      } else{
        let claveImagen = datosBypCopia.datosCopia.newNameFile.split('_');
        console.log("claveImgCopia:",claveImagen);
        claveImagen.forEach((clave,i) => {
          if(i < (claveImagen.length - 1)){
            nombreImagen = nombreImagen + clave;
            if(i < (claveImagen.length - 2)){ nombreImagen = nombreImagen + "_"; }
          }
        });
      }
      // nombreImagen = datosBypass.file.name;
    }
    console.log("nombreFinal:",nombreImagen);

    this.cloudService.getCarpeta(carpetaBroker._id).subscribe((respuesta:any) => {
      if(respuesta.success){
        let indiceArchivo: number;
        if(idxBg != null){
          indiceArchivo = respuesta.archivos.findIndex(item => item.nombre == nombreImagen);
        } else{
          indiceArchivo = respuesta.archivos.findIndex(item => item.nombre.includes(nombreImagen));
        }
        if(indiceArchivo != -1){
          this.cloudService.borraArchivo(respuesta.archivos[indiceArchivo]._id).subscribe((respuestaDel:any) => {
            if(respuestaDel.success){
              if(idxBg != null){
                this.jsonsConfiguracion[idioma][pagina].backgrounds.splice(idxBg,1);
                this.actualizaJson(idioma);
              } else{
                if(datosBypass != null){
                  this.datasets[datosBypass.idxPag].controls[`${datosBypass.idioma}_${datosBypass.pagina}_${datosBypass.paso}_${datosBypass.elemento}`].setValue('');
                  if(datosBypass.formData != undefined){
                    this.onFileChange(null, datosBypass.idxPag, datosBypass.pagina, datosBypass.paso, datosBypass.elemento, datosBypass.idioma, 2, datosBypass.formData);
                  } else{
                    this.guardaImagenCargada(datosBypass.file, datosBypass.idxPag, datosBypass.pagina, datosBypass.paso, datosBypass.elemento, datosBypass.idioma, datosBypass.background);
                  }
                } else{
                  this.copiarImagen(datosBypCopia);
                }
              }
            }
          });
        } else{
          if(idxBg != null){
            this.jsonsConfiguracion[idioma][pagina].backgrounds.splice(idxBg,1);
            this.actualizaJson(idioma);
          } else{
            if(datosBypass != null){
              this.datasets[datosBypass.idxPag].controls[`${datosBypass.idioma}_${datosBypass.pagina}_${datosBypass.paso}_${datosBypass.elemento}`].setValue('');
              if(datosBypass.formData != undefined){
                this.onFileChange(null, datosBypass.idxPag, datosBypass.pagina, datosBypass.paso, datosBypass.elemento, datosBypass.idioma, 2, datosBypass.formData);
              } else{
                this.guardaImagenCargada(datosBypass.file, datosBypass.idxPag, datosBypass.pagina, datosBypass.paso, datosBypass.elemento, datosBypass.idioma, datosBypass.background);
              }
            } else{
              this.copiarImagen(datosBypCopia);
            }
          }
        }
      }
    });
  }

  cambiarImagen(idxPag:number, idxPaso:number, idxElm:number, idioma:string, tipo:string) {
    $(`#${tipo}${idioma}-${idxPag}-${idxPaso}-${idxElm}`).click();
  }

  onFileChange(evt: any, idxPag:number, pagina:string, paso:string, elemento:string, idioma:string, etapa:number, formData?:any) {
    this.guardandoArchivo = true;
		/* wire up file reader */

    if(etapa == 1){
      const target: DataTransfer = <DataTransfer>(evt.target);
      if (target.files.length !== 1) throw new Error('Cannot use multiple files');
      let indiceBroker = this.institutos.findIndex(item => item.numInstituto == this.brokerElegido);
      let carpetaBroker = this.carpetasBrokers[this.institutos[indiceBroker].indiceCarpeta];
      let ubicacion = `${carpetaBroker.ubicacion}${carpetaBroker.nombre}/`;
      const reader: FileReader = new FileReader();
      let archivo = evt.target.files[0];
      let nomSplit = archivo.name.split(".");

      let fd = new FormData();
      let nombreArchivo = `${idioma}_${pagina}_${paso}_${elemento}_${Date.now()}.${nomSplit[nomSplit.length - 1]}`;
      fd.append('file',archivo, nombreArchivo);
      fd.append('ubicacion',ubicacion);
      fd.append('carpetaId',carpetaBroker._id);
      // console.log(...fd);
      // new Response(fd).text().then(console.log);
      // console.log("datosFD:",fd.get('file'));
      let datosBypass = {file:null, idxPag, pagina, paso, elemento, idioma, background:null, formData:fd};
      this.borrarImagen(idioma, pagina, null, datosBypass);
      evt.target.value = '';
    } else if(etapa == 2){
      this.cloudService.guardaArchivo(formData).subscribe((res) => {
        // console.log(res)
        if(res.status){
          if(res.status == "progress"){
            this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          this.guardandoArchivo = false;
          this.progresoCarga = 0;
          let url = DATOS_API.url.split(":");
          let htp = DATOS_API.url.split("/");
          let urlFileManager = DATOS_API.urlFileManager;
          let urlArchivoCargado = htp[0] + url[1] + urlFileManager + res.archivo.ubicacion.substr(2) + res.archivo.nombre;
          this.datasets[idxPag].controls[`${idioma}_${pagina}_${paso}_${elemento}`].setValue(urlArchivoCargado);
          this.modificarDatoJson(idxPag, pagina, paso, elemento, idioma);
        }
        else{
          if(res.message == 'archivo_save_1'){
            this.guardandoArchivo = false;
            this.progresoCarga = 0;
          }
        }
      },(err) => console.log(err));
    }
	}

  openCropperDialog(event: Event, idxPag:number, pagina:string, paso:string, elemento:string, idioma:string, background?:boolean) {
    // this.cropped = null!;
    this._dialog.open<ModalImgComponent, any>(ModalImgComponent, {
      data: {transparente: true, event},
      disableClose: true
    // }).afterClosed.subscribe((result?: ImgCropperEvent, objDrop?: any) => {
    }).afterClosed.subscribe((result?: any) => {
      let [resultado,objDrop] = result;
      if (resultado) {
        // this.cropped[`${pagina}_${paso}_${elemento}`] = resultado.dataURL;
        this._cd.markForCheck();
        console.log("resultado:",resultado);
        console.log("objDrop:",objDrop);

        fetch(resultado.dataURL)
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            // Here's where you get access to the blob
            // And you can use it for whatever you want
            // Like calling ref().put(blob)

            // Here, I use it to make an image appear on the page
            // let objectURL = URL.createObjectURL(blob);
            // let myImage = new Image();
            // myImage.src = objectURL;
            // document.getElementById('myImg').appendChild(myImage)
            console.log("blob:",blob);
            // let nombreRandom = Math.floor(Math.random() * (999999 - 100000 + 1) ) + 100000;
            // let file = new File([blob], nombreRandom.toString(), {type: objDrop.type});
            let nombreArchivo: string;
            if(background != undefined){
              nombreArchivo = `${idioma}_${pagina}_${paso}_${Date.now()}`;
            } else{
              nombreArchivo = `${idioma}_${pagina}_${paso}_${elemento}_${Date.now()}`;
            }
            let file = new File([blob], nombreArchivo, {type: objDrop.type});
            console.log("file:",file);
            if(background != undefined){
              this.guardaImagenCargada(file, idxPag, pagina, paso, elemento, idioma, background);
            } else{
              let datosBypass = {file, idxPag, pagina, paso, elemento, idioma, background};
              this.borrarImagen(idioma, pagina, null, datosBypass);
            }

        });
      }
    });
  }

  guardaImagenCargada(archivo:any, idxPag:number, pagina:string, paso:string, elemento:string, idioma:string, background?:boolean){
    let indiceBroker = this.institutos.findIndex(item => item.numInstituto == this.brokerElegido);
    let carpetaBroker = this.carpetasBrokers[this.institutos[indiceBroker].indiceCarpeta];
    let ubicacion = `${carpetaBroker.ubicacion}${carpetaBroker.nombre}/`;
    const reader: FileReader = new FileReader();
    let fd = new FormData();
    fd.append('file',archivo, archivo.name);
    fd.append('ubicacion',ubicacion);
    fd.append('carpetaId',carpetaBroker._id);
    // fd.append('ubicacion',this.direccionRaiz);
    // fd.append('empresaId',this.idEmpresa);
    // console.log(...fd);
    this.cloudService.guardaArchivo(fd).subscribe((res) => {
        // console.log(res)
        if(res.status){
          if(res.status == "progress"){
            // this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          console.log("cargaOk:",res);
          let url = DATOS_API.url.split(":");
          let htp = DATOS_API.url.split("/");
          let urlFileManager = DATOS_API.urlFileManager;
          let urlImagenCargada = htp[0] + url[1] + urlFileManager + res.archivo.ubicacion.substr(2) + res.archivo.nombre;
          if(!background){
            this.datasets[idxPag].controls[`${idioma}_${pagina}_${paso}_${elemento}`].setValue(urlImagenCargada);
            this.modificarDatoJson(idxPag, pagina, paso, elemento, idioma);
          } else{
            this.jsonsConfiguracion[idioma][pagina].backgrounds.push({
              image: urlImagenCargada
            });
            this.actualizaJson(idioma);
          }
        }
        else{
          if(res.message == 'archivo_save_1'){
            // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
            // this.guardandoArchivo = false;
            // this.progresoCarga = 0;
          }
        }
      },
      (err) => console.log(err)
    );
  }

  modificarDatoJson(idxPag:number, pagina:string, paso:string, elemento:string, idioma:string){
    let clave = `${idioma}_${pagina}_${paso}_${elemento}`;
    let camino = clave.split("_");
    this.navegaJsonRecursivo(idxPag,clave,this.jsonsConfiguracion,camino,0);  //aqui se actualiza el json de datos
  }
  navegaJsonRecursivo(indicePagina:number, claveForm:string, datoActual:any, camino:any[], iter:number, esArreglo?:boolean, soloGet?:boolean){
    // console.log("entroRecu, indicePagina:",indicePagina,"claveForm:",claveForm,"datos:",datoActual,"camino:",camino,"iter:",iter,"arreglo?:",esArreglo);
    let referenciaDataSet = this.datasets;
    if(camino[iter] != undefined){
      if(iter < (camino.length - 1)){
        if(esArreglo){
          if(datoActual[parseInt(camino[iter])] != undefined){
            this.navegaJsonRecursivo(indicePagina,claveForm,datoActual[parseInt(camino[iter])],camino,(iter + 1),Array.isArray(datoActual[parseInt(camino[iter])]),soloGet);
          }
        } else{
          if(datoActual.hasOwnProperty(camino[iter])){
            this.navegaJsonRecursivo(indicePagina,claveForm,datoActual[camino[iter]],camino,(iter + 1),Array.isArray(datoActual[camino[iter]]),soloGet);
          }
        }
      } else{
        if(datoActual.hasOwnProperty(camino[iter])){
          if(soloGet){
            // console.log("datoObtenido:",datoActual[camino[iter]]);
            // if(this.camposImagen.includes(camino[iter])){
            //   referenciaDataSet[indicePagina].controls[claveForm].setValue(this.arreglaUrlImgDef(datoActual[camino[iter]]));
            // } else{
              referenciaDataSet[indicePagina].controls[claveForm].setValue(datoActual[camino[iter]]);
            // }
          }
          else{
            let datoModificado = referenciaDataSet[indicePagina].controls[claveForm].value;
            // console.log("datoMod:-",datoModificado,"- datoJson:-",datoActual[camino[iter]],"-");
            if(datoModificado != datoActual[camino[iter]]){
              console.log("el dato es diferente");
              datoActual[camino[iter]] = datoModificado;
              this.actualizaJson(camino[0]);
            } else{
              console.log("el dato es igual");
            }
          }
        }
      }
    }
  }

  actualizaJson(idioma:string){
    let referenciaJsons = this.jsonsConfiguracion;
    let datosJson = referenciaJsons[idioma];
    // console.log("datosJson:",datosJson);
    let datosActualizar: any = {
      home: datosJson.home,
      login: datosJson.login
    };
    console.log(`datosActualizar:`,datosActualizar);
    this.guardandoTemplate = true;
    this.ebs.update(datosJson._id, datosActualizar).subscribe((respuesta:any) => {
      console.log("updateJson:",respuesta);
      if(respuesta.success){
        this.guardandoTemplate = false;
      }
    });

  }

  modificaTemplateCorreo(idxPag:number, pagina:string, paso:string, elemento:string, idioma:string){
    let referenciaDataSet = this.datasets;
    let claveAsunto = `${idioma}_${pagina}_${paso}_asunto`;
    let claveMensaje = `${idioma}_${pagina}_${paso}_mensaje`;
    let claveIdTemplate = `${idioma}_${pagina}_${paso}_idTemplate`;
    let idTemplate = referenciaDataSet[2].controls[claveIdTemplate].value;
    let datos = {
      asunto: referenciaDataSet[2].controls[claveAsunto].value,
      html: referenciaDataSet[2].controls[claveMensaje].value
    };
    console.log("datosTemplate:",datos);
    this.guardandoTemplate = true;
    this.ebs.updateCorreos(idTemplate, datos).subscribe((respuesta:any) => {
      console.log("updateCorreos:",respuesta);
      if(respuesta.success){
        this.guardandoTemplate = false;
      }
    });
  }

  getRaiz(){
    // let idEmpresa: string;
    this.cloudService.getCarpetaRaiz('1').subscribe( (respuesta:any) => {
      console.log("getRaiz:",respuesta);
      if(respuesta.carpetas.length == 0){
        this.guardaCarpeta('brokerAssets');
      } else{
        let idxCarpetaAssets = respuesta.carpetas.findIndex(item => item.nombre == 'brokerAssets');
        if(idxCarpetaAssets != -1){
          this.revisaDirectorios(respuesta.carpetas[idxCarpetaAssets]);
        } else{
          this.guardaCarpeta('brokerAssets');
        }
      }
    });
  }

  revisaDirectorios(carpetaAssets:any){
    const carpetaCreada = (broker) => broker.indiceCarpeta != -1;
    this.cloudService.getCarpeta(carpetaAssets._id).subscribe((respuesta:any) => {
      console.log("getCarpetaAssets:",respuesta);
      let BreakException = {};
      try {
        this.institutos.forEach((instituto, i) => {
          let idxCarpetaBroker = respuesta.subcarpetas.findIndex(item => item.nombre == instituto.numInstituto.toString());
          instituto.indiceCarpeta = idxCarpetaBroker;
          if(idxCarpetaBroker == -1){
            this.guardaCarpeta(instituto.numInstituto.toString(), this.direccionRaiz + carpetaAssets.nombre + '/', carpetaAssets);
            throw BreakException;
          }
        });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      if(this.institutos.every(carpetaCreada)){
        console.log("todas las carpetas de los brokers existen, via 1");
        this.carpetasBrokers = respuesta.subcarpetas;
        // this.institutos.forEach((instituto, i) => {
        //   let idxCarpetaBroker = respuesta.subcarpetas.findIndex(item => item.nombre == instituto.numInstituto.toString());
        //   this.revisaSubdirectorios(respuesta.subcarpetas[idxCarpetaBroker]);
        // });
      }
    });
  }

  revisaSubdirectorios(carpetaBroker:any){
    this.cloudService.getCarpeta(carpetaBroker._id).subscribe((respuesta:any) => {
      console.log(`getCarpetaAssets ${carpetaBroker.nombre} :`,respuesta);
    });
  }

  guardaCarpeta(nombre:string, ubicacion?:string, carpetaAssets?:any){
    let datos:any = {
      nombre: nombre,
      ubicacion: ubicacion != undefined ? ubicacion : this.direccionRaiz
    };
    if(carpetaAssets){
      datos.carpetaId = carpetaAssets._id;  //solo cuando no es la raiz
    }
    console.log(datos);

    this.cloudService.guardaCarpetaITBM(datos).subscribe((respuesta:any) => {
      console.log("guardaCarpetaITBM:",respuesta);
      if(respuesta.success){
        if(nombre == 'brokerAssets'){
          this.getRaiz();
        }
        if(ubicacion != undefined){
          this.revisaDirectorios(carpetaAssets);
        }
      }
    }, error => {
      console.log(error);
    });
  }

  verAdvertencia(mensaje:string){
    Swal.fire({
      icon: 'warning',
      title: this.translateSrv.instant(`EDITOR.ADVERTENCIAS.${mensaje}`),

      confirmButtonText: 'OK',
    });
  }

}
